var _rect, _path, _path2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWhatsappIcon = function SvgWhatsappIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 6,
    fill: "url(#paint0_linear_20868_6211)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05434 11.4046C5.05398 12.5361 5.35191 13.6408 5.91833 14.6145L5 17.9414L8.43134 17.0487C9.37679 17.5602 10.4413 17.8298 11.5244 17.8302H11.5272C15.0945 17.8302 17.9985 14.9497 18 11.4097C18.0006 9.6941 17.3279 8.08084 16.1059 6.86726C14.8837 5.65382 13.2587 4.98508 11.5272 4.98438C7.95933 4.98438 5.05576 7.86453 5.05434 11.4046ZM7.09782 14.4468L6.9697 14.245C6.43112 13.3952 6.14684 12.4133 6.14725 11.405C6.14837 8.46258 8.5617 6.06872 11.5293 6.06872C12.9664 6.06932 14.3169 6.6252 15.3328 7.63375C16.3485 8.64241 16.9075 9.98323 16.9071 11.4093C16.9058 14.3517 14.4924 16.7458 11.5272 16.7458H11.5251C10.5596 16.7453 9.61266 16.4881 8.78686 16.0019L8.59034 15.8862L6.55411 16.416L7.09782 14.4468Z",
    fill: "url(#paint1_linear_20868_6211)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.909 8.71852C9.78784 8.45131 9.66033 8.44592 9.54511 8.44123C9.45075 8.4372 9.34289 8.43751 9.23514 8.43751C9.12728 8.43751 8.95203 8.47776 8.8039 8.63825C8.65562 8.79889 8.23779 9.18707 8.23779 9.97659C8.23779 10.7661 8.81736 11.5292 8.89815 11.6364C8.97905 11.7433 10.017 13.4154 11.6609 14.0586C13.0271 14.5932 13.3052 14.4869 13.6017 14.4601C13.8982 14.4334 14.5586 14.072 14.6933 13.6973C14.8281 13.3226 14.8281 13.0014 14.7877 12.9343C14.7473 12.8674 14.6394 12.8273 14.4777 12.7471C14.316 12.6668 13.5208 12.2786 13.3725 12.225C13.2243 12.1715 13.1164 12.1448 13.0086 12.3055C12.9007 12.4659 12.591 12.8273 12.4966 12.9343C12.4023 13.0416 12.3079 13.0549 12.1462 12.9747C11.9844 12.8941 11.4635 12.7249 10.8456 12.1782C10.3648 11.7529 10.0402 11.2276 9.94582 11.0669C9.85147 10.9064 9.93571 10.8195 10.0168 10.7395C10.0895 10.6676 10.1786 10.5521 10.2595 10.4585C10.3402 10.3647 10.3671 10.2979 10.421 10.1908C10.475 10.0837 10.448 9.99 10.4076 9.90973C10.3671 9.82946 10.0528 9.03581 9.909 8.71852Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20868_6211",
    x1: 1150,
    y1: 2300,
    x2: 1150,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20868_6211",
    x1: 655,
    y1: 1300.69,
    x2: 655,
    y2: 4.98438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsappIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp-icon.97124145.svg";
export { ForwardRef as ReactComponent };